const SESSION_STORAGE = {
  productList: 'productList.products'
}

export {
  SESSION_STORAGE
}
